import AuthTypes from '../action-types/auth';
import SessionTypes from '../action-types/session';

const internals = {
    initial: () => ({
        isAuthenticated: false,
        isNewUser: false,
        error: false,
        errorMsg: '',
        credentials: {
            token: '',
        },
        requestReset: {
            error: false,
            errorMsg: '',
            completed: false,
        },
        reset: {
            error: false,
            errorMsg: '',
            completed: false,
        },
    }),
};

const AuthReducer = (stateParam, action) => {
    const state = stateParam || internals.initial();

    const { payload, type } = action;

    switch (type) {
    case AuthTypes.INITIALIZE_APP:
        return {
            ...state,
            error: false,
            errorMsg: '',
            requestReset: {
                error: false,
                errorMsg: '',
                completed: false,
            },
            reset: {
                error: false,
                errorMsg: '',
                completed: false,
            },
        };
    case AuthTypes.LOGIN_BEGIN:
        return {
            ...state,
            ...payload,
        };
    case AuthTypes.LOGIN_SUCCESS:
        return {
            ...state,
            isAuthenticated: true,
            credentials: {
                token: payload.token,
                role: payload.role,
            },
            error: false,
            errorMsg: '',
        };
    case AuthTypes.LOGIN_ERROR:
        return {
            ...state,
            isAuthenticated: false,
            error: true,
            errorMsg: payload.errorMsg,
        };
    case AuthTypes.LOGOUT:
        return {
            ...state,
            isAuthenticated: false,
            credentials: { token: '' },
        };
    case AuthTypes.REQUEST_RESET_BEGIN:
        return {
            ...state,
            requestReset: {
                error: false,
                errorMsg: '',
                completed: false,
            },
        };
    case AuthTypes.REQUEST_RESET_SUCCESS:
        return {
            ...state,
            requestReset: {
                error: false,
                errorMsg: '',
                completed: true,
            },
        };
    case AuthTypes.REQUEST_RESET_ERROR:
        return {
            ...state,
            requestReset: {
                error: true,
                errorMsg: payload.errorMsg,
                completed: true,
            },
        };
    case AuthTypes.RESET_BEGIN:
        return {
            ...state,
            phone: payload.phone,
            reset: {
                error: false,
                errorMsg: '',
                completed: false,
            },
        };
    case AuthTypes.RESET_SUCCESS:
        return {
            ...state,
            isAuthenticated: true,
            credentials: {
                token: payload.token,
                role: payload.role,
            },
            reset: {
                error: false,
                errorMsg: '',
                completed: true,
            },
        };
    case AuthTypes.RESET_ERROR:
        return {
            ...state,
            isAuthenticated: false,
            reset: {
                error: true,
                errorMsg: payload.errorMsg,
                completed: true,
            },
        };
    case AuthTypes.SETUP_NEW_USER_BEGIN:
        return {
            ...state,
            isNewUser: true,
        };
    case AuthTypes.SETUP_NEW_USER_SUCCESS:
        return {
            ...state,
            isNewUser: false,
        };
    case SessionTypes.CLEAR_SESSION:
        return internals.initial();

    default:
        // do nothing
    }
    return state;
};

export default AuthReducer;
